import utils from 'utils'
import fuzzySearch from "../../basedata/taxAccount/fuzzysearch";
class systemParamsListCtrl {
    constructor($rootScope, $scope, $uibModal, logger, httpRequest) {
        // 初始化表格数据
        $scope.param = {
            ivat: [],
            ovat: [],
            sys: [],
        }
        $scope.userType = $rootScope.userInfo.user.userType
        console.log($rootScope.userInfo.user.userType)

        function queryInfo() {
            httpRequest.get_SysParamMap().then(
                (res) => {
                    const _res = res.data.value
                    for (const key in _res) {
                        _res[key].forEach((ele) => {
                            if (ele.paramSelection) {
                                const selectArr = JSON.parse(ele.paramSelection)
                                ele.optionType = selectArr.type
                                ele.optionArr = selectArr.operations
                                ele.needSetting = selectArr.needSetting
                                if (selectArr.type == 'switch') {
                                    ele.paramValue = Number(ele.paramValue)
                                }
                            }
                        })
                    }
                    $scope.param.ivat = _res.ivat
                    for (const item of $scope.param.ivat) {
                        if (item.paramCode == 'ivat_auto_check_range') {
                            item.enable = parseInt(JSON.parse(item.paramValue).enable)
                        }
                    }
                    $scope.param.ovat = _res.ovat
                    $scope.param.sys = _res.sys
                    $scope.param.ovatConf = _res['ovat-conf']
                },
            )
        }

        $scope.setSelectParams = function (item) {
            console.log(item)
            if (item.paramCode == 'ivat_auto_check_range') {
                if (item.enable == '0') {
                    let paramValue = JSON.parse(item.paramValue)
                    paramValue.enable = '1'
                    item.paramValue = JSON.stringify(paramValue)
                } else {
                    let paramValue = JSON.parse(item.paramValue)
                    paramValue.enable = '0'
                    item.paramValue = JSON.stringify(paramValue)
                }
            }
            console.log(item)
            // BEGIN: fix by wxb 选择组件有问题，反着来
            if (item.optionType == 'switch') {
                if (item.paramValue == '0') {
                    item.paramValue = '1'
                } else {
                    item.paramValue = '0'
                }
            }
            updateHandle(item)
        }

        function updateHandle(item) {
            let arr = JSON.stringify(item)
            arr = JSON.parse(arr)
            delete arr.optionType
            delete arr.optionArr
            utils.loading('保存中...')
            httpRequest.post_updateSysParam([arr]).then(
                (res) => {
                    logger.logSuccess(res.data.message || '操作成功')
                    queryInfo()
                },
            ).finally(() => {
                utils.loaded()
            })
        }

        function updateVoucherHandle(params) {
            httpRequest.post_ivatVoucherAccountSetting(params).then(res => {
                logger.logSuccess(res.data.message || '设置成功')
                queryInfo()
            })
        }
        // 对照规则配置
        $scope.contrastRules = (item) => {
            if (item.paramCode === "ovat_eletc_email_conf_rule") {
                $uibModal.open({
                    templateUrl: 'contrastRules.html',
                    openedClass: 'mod-modal mod-modal-md',
                    controller: ['$scope', '$uibModalInstance', 'logger', 'sweetalert', 'httpRequest', function ($scope, $uibModalInstance, logger, sweetalert, httpRequest) {
                        $scope.paramCode = 'ovat_eletc_email_conf_rule'
                        $scope.title = '电子票发送设置'
                        $scope.sendRules = [{
                            text: '单张发送（发票实时发送）',
                            val: '1'
                        },
                        {
                            text: '批量发送（系统将根据相同邮箱定时批量打包发送发票）',
                            val: '2'
                        },
                        ]
                        $scope.params = {
                            emailServerType: "",
                            sendType: "",
                            confId: "",
                            userName: "",
                            needSsl: "",
                            password: "",
                            serverIp: "",
                            serverPort: ""
                        }
                        httpRequest.get_selectConfigByLoginUser().then(res => {
                            if (res.data.value) {
                                let result = res.data.value
                                Object.keys($scope.params).forEach(key => {
                                    if (result[key]) $scope.params[key] = result[key] + ''
                                })
                            }
                        })
                        $scope.cancel = function cancel() {
                            $uibModalInstance.close()
                        }

                        function checkHandle(params) {
                            if ($scope.params.emailServerType == 3 && (!params.userName || !params.serverIp || !params.password || !params.serverPort)) {
                                logger.logTips('自定义邮箱需要设置邮箱内容，请先前往设置', 'warn')
                                return false
                            }
                            if (!$scope.params.emailServerType || !$scope.params.sendType) {
                                logger.logTips('无法获取默认值请稍后再试', 'warn')
                                return false
                            }
                            return true
                        }
                        $scope.selectSpecail = function () {
                            if ($scope.params.emailServerType == 1) {
                                $scope.params.sendType = '1'
                            }
                        }
                        $scope.ok = function ok() {
                            if (checkHandle($scope.params)) {
                                $scope.requesting = true
                                httpRequest.post_ovatEletcEmailConfUpdateConfig($scope.params).then(res => {
                                    if (res.data.success) {
                                        logger.logSuccess(res.data.message || '设置成功')
                                    }
                                    $uibModalInstance.close()
                                }).finally(() => {
                                    $scope.requesting = false
                                })
                            }
                        }

                        $scope.setService = function setService() {
                            if (!$scope.params.emailServerType || !$scope.params.sendType) {
                                logger.logTips('无法获取系统默认值请稍后再试', 'warn')
                                return false
                            }
                            $uibModal.open({
                                templateUrl: 'emailSetting.html',
                                openedClass: 'mod-modal mod-modal-md modal-edit-taxpayer-container',
                                animation: true,
                                controller: ['$scope', '$uibModalInstance', 'httpRequest', 'logger', 'obj', function ($scope, $uibModalInstance, httpRequest, logger, obj) {
                                    $scope.params = JSON.parse(JSON.stringify(obj.params))
                                    $scope.cancel = function cancel() {
                                        $uibModalInstance.close()
                                    }
                                    $scope.needSsl = $scope.params.needSsl == 1 ? true : false
                                    $scope.SSLDefaultFlag = function SSLDefaultFlag(val) {
                                        $scope.params.needSsl = val ? 1 : 0
                                    }
                                    function submitCheck(params) {
                                        if (!params.userName) {
                                            logger.logTips('请输入用户名', 'warn')
                                            return false
                                        }
                                        const regex = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
                                        if (!regex.test(params.userName)) {
                                            logger.logTips('用户名为邮箱地址', 'warn')
                                            return false
                                        }
                                        let emailUserName = params.userName.split('@')
                                        if ((emailUserName[0] + '').length > 64 || (emailUserName[1] + '').length > 255) {
                                            logger.logTips('用户名格式错误', 'warn')
                                            return false
                                        }
                                        if (!params.serverIp) {
                                            logger.logTips('请输入服务器地址', 'warn')
                                            return false
                                        }
                                        const sregex = /^([a-zA-Z\d][a-zA-Z\d-_]+\.)+[a-zA-Z\d-_][^ ]*$/
                                        if (!sregex.test(params.serverIp)) {
                                            logger.logTips('服务器地址不合法', 'warn')
                                            return false
                                        }
                                        if (!params.password) {
                                            logger.logTips('请输入密码', 'warn')
                                            return false
                                        }
                                        if (!params.serverPort) {
                                            logger.logTips('请输入服务器端口', 'warn')
                                            return false
                                        }
                                        const oregx = /^[0-9]*$/;
                                        if (!oregx.test(params.serverPort)) {
                                            logger.logTips('服务器端口只能是数字', 'warn')
                                            return false
                                        }
                                        if (params.serverPort > 65535) {
                                            logger.logTips('服务器端口号不能大于65535', 'warn')
                                            return false
                                        }
                                        return true
                                    }
                                    $scope.ok = function ok() {
                                        if (submitCheck($scope.params)) {
                                            utils.loading('处理中')
                                            httpRequest.post_ovatEletcEmailConfUpdateConfig($scope.params).then(res => {
                                                if (res.data.success) {
                                                    Object.keys(obj.params).forEach(key => obj.params[key] = $scope.params[key])
                                                    if (res.data.value.confId) { obj.params.confId = res.data.value.confId }
                                                    logger.logSuccess('设置成功')
                                                    $uibModalInstance.close()
                                                }
                                            }).finally(() => {
                                                utils.loaded()
                                            })
                                        }
                                    }
                                }],
                                resolve: {
                                    obj() {
                                        return {
                                            params: $scope.params
                                        }
                                    },
                                },
                            })
                        }
                    }],
                    resolve: {
                        obj() {
                            return {}
                        },
                    },
                })
            } else if (item.paramCode === "ivat_voucher_account_setting") {
                $uibModal.open({
                    templateUrl: 'contrastRules.html',
                    openedClass: 'mod-modal mod-modal-md',
                    animation: true,
                    controller: ['$scope', '$uibModalInstance', 'logger', 'sweetalert', 'obj', function ($scope, $uibModalInstance, logger, sweetalert, obj) {
                        $scope.paramCode = 'ivat_voucher_account_setting'
                        $scope.title = '财税对账设置'
                        let params = JSON.parse(JSON.stringify(obj.item))
                        let vals = params.paramValue.split(',')
                        $scope.invoiceTypes = [{
                            text: '增值税发票',
                            selected: false,
                            disabled: true
                        },
                        {
                            text: '客运发票',
                            selected: false
                        }
                        ]
                        if (vals[0] && vals[0] == 3) {
                            $scope.invoiceTypes.forEach(item => {
                                item.selected = true
                            })
                        } else {
                            $scope.invoiceTypes[vals[0] - 1].selected = true
                        }
                        $scope.modelType = [{
                            text: '凭证号对账（需预先设置发票关联的凭证号比对）',
                            val: 1
                        },
                        {
                            text: '总税额对账（账务进项税额与发票进项税额总额比对）',
                            val: 2
                        },
                        {
                            text: '税额明细对账（根据税额相同的账票自动匹配）',
                            val: 3
                        },
                        ]
                        $scope.currentModel = {
                            val: vals[1]
                        }
                        $scope.cancel = function cancel() {
                            $uibModalInstance.close()
                        }

                        $scope.ok = function ok() {
                            let invoiceTypeVal = $scope.invoiceTypes[0].selected && $scope.invoiceTypes[1].selected ? 3 : $scope.invoiceTypes[0].selected ? 1 : $scope.invoiceTypes[1].selected ? 2 : 0
                            if (invoiceTypeVal == 0) {
                                logger.logTips('请设置对账发票', 'warn')
                                return
                            }
                            httpRequest.get_checkAccountIsConfire().then(res => {
                                params.paramValue = invoiceTypeVal + ',' + $scope.currentModel.val
                                if (res.data.value && res.data.value.accountStatus == 3) {
                                    sweetalert.confirm('操作提醒', '修改后将删除当前模式的对账结果及票账关联关系，需要重新对账，请谨慎操作；').then(() => {
                                        $uibModalInstance.close()
                                        updateVoucherHandle(params)
                                    })
                                } else {
                                    $uibModalInstance.close()
                                    updateVoucherHandle(params)
                                }
                            })
                        }
                    }],
                    resolve: {
                        obj() {
                            return {
                                item
                            }
                        },
                    },
                })
            } else if (item.paramCode === 'ovat_txt_import_module') {
                $uibModal.open({
                    templateUrl: 'contrastRules.html',
                    openedClass: 'mod-modal mod-modal-lg',
                    animation: true,
                    controller: ['$scope', '$uibModalInstance', 'obj', function ($scope, $uibModalInstance, obj) {
                        $scope.paramCode = 'ovat_txt_import_module'
                        $scope.enterList = []
                        $scope.selectVal = {}
                        $scope.title = '文本导入设置'
                        try {
                            $scope.enterList = JSON.parse(obj.item.paramSelection).operations || []
                            $scope.selectVal = JSON.parse(obj.item.paramValue) || {}
                        } catch (err) {
                            console.log('参数错误')
                        }
                        $scope.txt = {}
                        $scope.check = function () {
                            if ($scope.selectVal.ignoreChar.check == '0' && !$scope.selectVal.ignoreChar.charNum) return
                            if (!(/^[+]{0,1}(\d+)$/.test($scope.selectVal.ignoreChar.charNum))) {
                                $scope.txt.isWarn = true
                            }
                        }

                        $scope.cancel = function cancel() {
                            $uibModalInstance.close()
                        }

                        $scope.ok = function ok() {
                            if ($scope.txt.isWarn) return
                            obj.item.paramValue = JSON.stringify($scope.selectVal)
                            updateHandle(obj.item)
                            $uibModalInstance.close()
                        }
                    }],
                    resolve: {
                        obj() {
                            return {
                                item
                            }
                        },
                    },
                }).result.then(() => {

                })
            } else if (item.paramCode == 'ivat_auto_check_range') {
                $uibModal.open({
                    templateUrl: 'contrastRules.html',
                    openedClass: 'mod-modal mod-modal-lg',
                    animation: true,
                    controller: ['$scope', '$uibModalInstance', 'obj', 'logger', function ($scope, $uibModalInstance, obj, logger) {
                        $scope.paramCode = 'ivat_auto_check_range'
                        $scope.title = '自动勾选设置'
                        $scope.autoCheckDataRange = []
                        for (var i = 1; i <= 31; i++) {
                            if (i < 10) {
                                $scope.autoCheckDataRange.push(
                                    { name: '0' + i.toString(), val: '0' + i.toString() }
                                );
                            }
                            if (i > 9) {
                                $scope.autoCheckDataRange.push(
                                    { name: i.toString(), val: i.toString() }
                                );
                            }
                        }
                        console.log($scope.autoCheckDataRange)
                        $scope.item = JSON.parse(JSON.stringify(obj.item))
                        $scope.params = JSON.parse($scope.item.paramValue)


                        let verifyAfterCheckFail = $scope.params.verifyAfterCheckFail
                        let waitDeductionCheck = $scope.params.waitDeductionCheck
                        if (verifyAfterCheckFail == 1) $scope.params.verifyAfterCheckFail = true
                        if (verifyAfterCheckFail == 0) $scope.params.verifyAfterCheckFail = false
                        if (waitDeductionCheck == 1) $scope.params.waitDeductionCheck = true
                        if (waitDeductionCheck == 0) $scope.params.waitDeductionCheck = false
                        // "checkRange": "0","checkTimeStart": "","checkTimeEnd": "","verifyAfterCheckFail": "",
                        // "waitDeductionCheck": "","analyzingConditions": "0","enable":"0"}"

                        // $scope.atuoSelectAll1 = (i) => {
                        //     console.log(i)
                        // }
                        // $scope.atuoSelectAll2 = (i) => {
                        //     console.log(i)
                        // }
                        $scope.autoCheckRange = [
                            { name: '勾选', val: '0' },
                            { name: '勾选、统计', val: '1' },
                            { name: '勾选、统计、签名', val: '2' },
                        ]
                        $scope.modelType = [{
                            text: '归档状态=已完结 且 归档月份与税务所属期一致',
                            val: 0
                        },
                        {
                            text: '入账月份与税务所属期一致',
                            val: 1
                        },
                        {
                            text: '抵扣标志=允许、抵扣平台=勾选抵扣且入账月份与税款所属期一致',
                            val: 2
                        },
                        ]
                        $scope.txt = {}
                        $scope.check = function () {
                            if (!$scope.params.checkRange) return logger.logError('请选择自动勾选范围')
                            if (!$scope.params.checkTimeStart || !$scope.params.checkTimeEnd) return logger.logError('请选择每月自动勾选时间')
                            if (+$scope.params.checkTimeStart > +$scope.params.checkTimeEnd) return logger.logError('开始时间不能大于结束时间')
                            if ($scope.params.analyzingConditions == '' || $scope.params.analyzingConditions == null) return logger.logError('请选择判断条件')
                            return true
                        }

                        $scope.cancel = function cancel() {
                            $uibModalInstance.close()
                        }

                        $scope.ok = function ok() {
                            if ($scope.check()) {
                                let verifyAfterCheckFail = $scope.params.verifyAfterCheckFail
                                let waitDeductionCheck = $scope.params.waitDeductionCheck
                                if (verifyAfterCheckFail) $scope.params.verifyAfterCheckFail = 1
                                if (!verifyAfterCheckFail) $scope.params.verifyAfterCheckFail = 0
                                if (waitDeductionCheck) $scope.params.waitDeductionCheck = 1
                                if (!waitDeductionCheck) $scope.params.waitDeductionCheck = 0
                                console.log($scope.params)
                                obj.item.paramValue = JSON.stringify($scope.params)
                                updateHandle(obj.item)
                                $uibModalInstance.close()

                            }
                        }
                    }],
                    resolve: {
                        obj() {
                            return {
                                item
                            }
                        },
                    },
                }).result.then(() => {

                })

            }
            else if (item.paramCode === 'ovat_proxy_down_url') {
                $uibModal
                    .open({
                        templateUrl: 'contrastRules.html',
                        openedClass: 'mod-modal mod-modal-lg',
                        animation: true,
                        controller: [
                            '$scope',
                            '$uibModalInstance',
                            'obj',
                            function ($scope, $uibModalInstance, obj) {
                                $scope.paramCode = 'ovat_proxy_down_url'
                                $scope.selectVal = {}
                                $scope.title = '全电发票下载预览代理地址'
                                try {
                                    $scope.selectVal = JSON.parse(obj.item.paramValue) || {}
                                } catch (err) {
                                    console.log('参数错误')
                                }
                                $scope.cancel = function cancel() {
                                    $uibModalInstance.close()
                                }
                                $scope.ok = function ok() {
                                    let userType = JSON.parse(localStorage.user_info).user.userType
                                    if (userType == 2 || userType == 1) {
                                        logger.logError('全电发票下载预览代理地址由系统管理员维护!')
                                        return
                                    }
                                    const sregex = /^(?:(http|https|ftp):\/\/)/
                                    if (!sregex.test($scope.selectVal.proxyDownUrl)) {
                                        logger.logTips('全电发票下载预览代理地址不合法', 'warn')
                                        return
                                    }
                                    obj.item.paramValue = JSON.stringify($scope.selectVal)
                                    updateHandle(obj.item)
                                    $uibModalInstance.close()
                                }
                            },
                        ],
                        resolve: {
                            obj() {
                                return {
                                    item,
                                }
                            },
                        },
                    })
                    .result.then(() => { })
            }
            else if (item.paramCode === 'sys_open_reason') {
                $uibModal
                    .open({
                        templateUrl: 'contrastRules.html',
                        openedClass: 'mod-modal mod-modal-lg',
                        animation: true,
                        controller: [
                            '$scope',
                            '$uibModalInstance',
                            'obj',
                            function ($scope, $uibModalInstance, obj) {
                                $scope.paramCode = 'sys_open_reason'
                                $scope.selectVal = {}
                                $scope.title = '政策有效期设置'
                                $scope.dateConfig = {
                                    format: 'yyyy-mm-dd',
                                    language: 'zh-CN',
                                    minView: 'month',
                                }
                                try {
                                    $scope.selectVal = JSON.parse(obj.item.paramValue) || {}
                                } catch (err) {
                                    console.log('参数错误')
                                }
                                $scope.cancel = function cancel() {
                                    $uibModalInstance.close()
                                }
                                $scope.ok = function ok() {
                                    let userType = JSON.parse(localStorage.user_info).user.userType
                                    if (userType == 2 || userType == 1) {
                                        logger.logError('政策有效期由系统管理员维护!')
                                        return
                                    }
                                    if ($scope.selectVal.startTime < '2023-01-01') {
                                        logger.logError('开始日期不得小于2023-01-01！')
                                        return
                                    }
                                    if ($scope.selectVal.startTime > $scope.selectVal.endTime) {
                                        logger.logError('开始日期不得大于结束日期！')
                                        return
                                    }
                                    obj.item.paramValue = JSON.stringify($scope.selectVal)
                                    updateHandle(obj.item)
                                    $uibModalInstance.close()
                                }
                            },
                        ],
                        resolve: {
                            obj() {
                                return {
                                    item,
                                }
                            },
                        },
                    })
                    .result.then(() => { })
            }
            else if (item.paramCode === 'sys_condition_config') {
                $uibModal
                    .open({
                        templateUrl: 'contrastRules.html',
                        openedClass: 'mod-modal mod-modal-lg',
                        animation: true,
                        controller: [
                            '$scope',
                            '$uibModalInstance',
                            'obj',
                            function ($scope, $uibModalInstance, obj) {
                                $scope.paramCode = 'sys_condition_config'
                                $scope.selectVal = {}
                                $scope.title = '查询条件日期范围设置'
                                const typecodeArrStr = '["date_range","page_entry","page_query_criteria"]'
                                httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
                                    $scope.dictData = res.data.value
                                })
                                let userType = JSON.parse(localStorage.user_info).user.userType
                                if (userType === 0) {
                                    $scope.hasAuthority = true
                                }
                                httpRequest.post_sysConditionConfigList({ configType: '1', profileType: '1' }).then((res) => {
                                    let data = res.data.value
                                    data.forEach(i => {
                                        i.profileInfo = JSON.parse(i.profileInfo)
                                        i.pageQueryCriteria = i.profileInfo.pageQueryCriteria
                                        i.dateRange = i.profileInfo.dateRange
                                        i.isEdit = false
                                    });
                                    $scope.listData = res.data.value
                                })
                                $scope.addData = function addData() {
                                    let data = {
                                        profileType: '',
                                        pageQueryCriteria: '',
                                        dateRange: '1',
                                        isEdit: true
                                    }
                                    $scope.listData.push(data)
                                }
                                $scope.editData = function editData(item) {
                                    item.isEdit = true
                                }
                                $scope.saveData = function saveData(item) {
                                    if (!item.profileType) return logger.logError("页面入口不能为空！")
                                    if (!item.pageQueryCriteria) return logger.logError("查询条件不能为空！")
                                    item.isEdit = false
                                    if (item.id) {
                                        let param = {
                                            id: item.id,
                                            profileType: item.profileType,
                                            profileInfo: JSON.stringify({
                                                pageQueryCriteria: item.pageQueryCriteria,
                                                dateRange: item.dateRange,
                                            }),
                                            configType: '1',
                                        }
                                        httpRequest.post_sysConditionConfigUpdateOne(param).then((res) => { })
                                    } else {
                                        let param = {
                                            profileType: item.profileType,
                                            profileInfo: JSON.stringify({
                                                pageQueryCriteria: item.pageQueryCriteria,
                                                dateRange: item.dateRange,
                                            }),
                                            configType: '1',
                                        }
                                        httpRequest.post_sysConditionConfigAddOne(param).then((res) => {
                                            item.id = res.data.value.id
                                        }, (error) => {
                                            if (error) {
                                                $scope.listData = $scope.listData.filter((x) => x !== item);
                                            }
                                        })
                                    }
                                }
                                $scope.delData = function delData(item) {
                                    if (item.id) {
                                        httpRequest.post_sysConditionConfigDelete(item.id).then((res) => {
                                            if (res.data.value) {
                                                $scope.listData = $scope.listData.filter((x) => x !== item);
                                            } else {
                                                logger.logError("删除失败")
                                            }
                                        })
                                    } else {
                                        $scope.listData = $scope.listData.filter((x) => x !== item);
                                    }
                                }
                                $scope.cancel = function cancel() {
                                    $uibModalInstance.close()
                                }
                                $scope.ok = function ok() {
                                    $uibModalInstance.close()
                                }
                            },
                        ],
                        resolve: {
                            obj() {
                                return {
                                    item,
                                }
                            },
                        },
                    })
                    .result.then(() => { })
            }
            else if (item.paramCode === 'ovat_tax4_callback_rules') {
                $uibModal
                    .open({
                        templateUrl: 'contrastRules.html',
                        openedClass: 'mod-modal mod-modal-hg',
                        animation: true,
                        controller: [
                            '$scope',
                            '$uibModalInstance',
                            'obj',
                            function ($scope, $uibModalInstance, obj) {
                                $scope.paramCode = 'ovat_tax4_callback_rules'
                                $scope.selectVal = {}
                                $scope.title = '全电发票开具事件回调规则设置'
                                $scope.disableSw = false
                                let selectVal = []
                                let lqSelectVal = []
                                $scope.lqEnterList = [
                                    {
                                        "enumCode": "1",
                                        "enumName": "PDF"
                                    },
                                    {
                                        "enumCode": "3",
                                        "enumName": "XML"
                                    }
                                ]
                                try {
                                    $scope.enterList = JSON.parse(obj.item.paramSelection).operations || []
                                    $scope.selectVal = JSON.parse(obj.item.paramValue) || {}
                                    selectVal = JSON.parse(obj.item.paramValue).own.fileArray
                                    lqSelectVal = JSON.parse(obj.item.paramValue).lq.fileArray
                                    if ($scope.selectVal.lq.needUpload == 0) $scope.disableSw = true
                                } catch (err) {
                                    console.log('参数错误')
                                }
                                selectVal.forEach((item) => {
                                    for (var i = 0, len = $scope.enterList.length; i < len; i++) {
                                        if (item == $scope.enterList[i].enumCode) {
                                            $scope.enterList[i].selected = true
                                            break
                                        }
                                    }
                                })
                                lqSelectVal.forEach((item) => {
                                    for (var i = 0, len = $scope.lqEnterList.length; i < len; i++) {
                                        if (item == $scope.lqEnterList[i].enumCode) {
                                            $scope.lqEnterList[i].selected = true
                                            break
                                        }
                                    }
                                })
                                $scope.uploadChange = function uploadChange(val) {
                                    if (val === 0) {
                                        $scope.disableSw = true
                                        $scope.selectVal.lq.needDownload = 0
                                    } else {
                                        $scope.disableSw = false
                                    }
                                }
                                $scope.cancel = function cancel() {
                                    $uibModalInstance.close()
                                }
                                $scope.ok = function ok() {
                                    let userType = JSON.parse(localStorage.user_info).user.userType
                                    if (userType == 2 || userType == 1) {
                                        logger.logError('开具事件回调规则由系统管理员维护!')
                                        return
                                    }
                                    let arr = []
                                    let lqArr = []
                                    $scope.enterList.forEach((item) => {
                                        if (item.selected) arr.push(item.enumCode)
                                    })
                                    $scope.lqEnterList.forEach((item) => {
                                        if (item.selected) lqArr.push(item.enumCode)
                                    })
                                    $scope.selectVal.own.fileArray = arr
                                    $scope.selectVal.lq.fileArray = lqArr
                                    obj.item.paramValue = JSON.stringify($scope.selectVal)
                                    updateHandle(obj.item)
                                    $uibModalInstance.close()
                                }
                            },
                        ],
                        resolve: {
                            obj() {
                                return {
                                    item,
                                }
                            },
                        },
                    })
                    .result.then(() => { })
            } else if (item.paramCode === 'tax4_invoice_fail_retry_config' || item.paramCode === 'tax4_invoice_fail_callback_config') {
                $uibModal
                    .open({
                        templateUrl: 'failedToRetryTheConfiguration.html',
                        openedClass: 'mod-modal mod-modal-hg',
                        animation: true,
                        controller: [
                            '$scope',
                            '$uibModalInstance',
                            'obj',
                            function ($scope, $uibModalInstance, obj) {
                                $scope.paramCode = obj.item.paramCode
                                $scope.selectVal = {}
                                $scope.enterList = []
                                let selectVal = []
                                try {
                                    $scope.enterList = JSON.parse(obj.item.paramSelection).operations || []
                                    selectVal = obj.item.paramValue.split(',')
                                } catch (err) {
                                    console.log('参数错误')
                                }
                                selectVal.forEach((item) => {
                                    for (var i = 0, len = $scope.enterList.length; i < len; i++) {
                                        if (item == $scope.enterList[i].enumCode) {
                                            $scope.enterList[i].selected = true
                                            $scope.param = {
                                                paramValue: $scope.enterList[i].enumCode,
                                            }
                                            break
                                        }
                                    }
                                })
                                $scope.cancel = function cancel() {
                                    $uibModalInstance.close()
                                }
                                $scope.ok = function ok() {
                                    let paramValue = []
                                    $scope.enterList.forEach((item) => {
                                        if (item.selected) paramValue.push(item.enumCode)
                                    })
                                    obj.item.paramValue = paramValue.join(',')
                                    updateHandle(obj.item)
                                    $uibModalInstance.close()
                                }
                            },
                        ],
                        resolve: {
                            obj() {
                                return {
                                    item,
                                }
                            },
                        },
                    })
                    .result.then(() => { })

            } else if (item.paramCode === 'drawer_auto_login_switch') {
                $uibModal
                    .open({
                        templateUrl: 'billerIsAutomaticallyLoggedIn.html',
                        openedClass: 'mod-modal mod-modal-md',
                        animation: true,
                        controller: [
                            '$scope',
                            '$uibModalInstance',
                            'obj',
                            function ($scope, $uibModalInstance, obj) {
                                httpRequest.get_dictByTypeArr(['drawer_auto_login_cron_config']).then((res) => {
                                    $scope.dictData = res.data.value;
                                });
                                httpRequest.get_getScheduleJob().then((res) => {
                                    $scope.timeConfig = res.data.value;
                                })
                                $scope.enterList = []
                                $scope.selectVal = Number(obj.item.paramValue)
                                try {
                                    $scope.enterList = JSON.parse(obj.item.paramSelection).operations || []
                                } catch (err) {
                                    console.log('参数错误')
                                }
                                $scope.cancel = function cancel() {
                                    $uibModalInstance.close()
                                }
                                $scope.ok = function ok() {
                                    obj.item.paramValue = Number($scope.selectVal)
                                    if (obj.item.paramValue == 1) {
                                        httpRequest.post_updateScheduleJob($scope.timeConfig).then((res) => {
                                            updateHandle(obj.item)
                                            $uibModalInstance.close()
                                        })
                                    } else {
                                        updateHandle(obj.item)
                                        $uibModalInstance.close()
                                    }
                                }
                            },
                        ],
                        resolve: {
                            obj() {
                                return {
                                    item,
                                }
                            },
                        },
                    })
                    .result.then(() => { })
            } else if (item.paramCode === "ivat_invoice_pool_collect_conf") {
                $uibModal.open({
                    templateUrl: 'contrastRules.html',
                    openedClass: 'mod-modal mod-modal-hg',
                    animation: true,
                    controller: ['$scope', '$uibModalInstance', 'logger', 'sweetalert', '$timeout', 'obj',
                        function ($scope, $uibModalInstance, logger, sweetalert, $timeout, obj) {
                        $scope.paramCode = 'ivat_invoice_pool_collect_conf'
                        $scope.title = '进项发票同步/下载参数设置'
                        $scope.openSyncFlag = 0
                        $scope.syncInvoiceType = [
                            {enumCode: '62', enumName: '电子发票（增值税专用发票）', selected: true},
                            {enumCode: '61', enumName: '电子发票（普通发票）', selected: true},
                            {enumCode: '0', enumName: '增值税专用发票', selected: true},
                            {enumCode: '2', enumName: '增值税普通发票', selected: true},
                            {enumCode: '51', enumName: '增值税电子普通发票', selected: true},
                            {enumCode: '63', enumName: '电子发票（铁路电子客票）', selected: false},
                            {enumCode: '64', enumName: '电子发票（航空运输客票电子行程单)', selected: false},
                            {enumCode: '66', enumName: '纸质发票（增值税专用发票）', selected: true},
                            {enumCode: '67', enumName: '纸质发票（普通发票）', selected: true},
                            {enumCode: '08', enumName: '增值税电子专用发票', selected: true},
                            {enumCode: '14', enumName: '通行费发票', selected: false},
                            {enumCode: '12', enumName: '机动车销售统一发票', selected: false},
                            {enumCode: '69', enumName: '机动车销售电子统一发票', selected: false},
                            {enumCode: '65', enumName: '二手车销售电子统一发票', selected: false},
                            {enumCode: '70', enumName: '纸质发票（机动车销售统一发票）', selected: false},
                            {enumCode: '68', enumName: '纸质发票（二手车销售统一发票）', selected: false},
                            {enumCode: '15', enumName: '二手车销售统一发票', selected: false}
                        ]
                        $scope.syncFileType = [{enumCode: 'XML', enumName: 'XML', selected: true},{enumCode: 'PDF', enumName: 'PDF', selected: true}]
                        $scope.syncInvoiceDateScope = [{enumCode: '1', enumName: '前一天'},{enumCode: '3', enumName: '近3天(含当天)'},{enumCode: '7', enumName: '近7天(含当天)'}]
                        $scope.selectedDateScope = '7'
                        $scope.historyOpen = 0
                        $scope.historyStart = ''

                        console.log(obj.item)
                        if(obj.item && obj.item.paramValue){
                            // 保存过配置，根据配置调整初始化值
                            var paramValue = JSON.parse(obj.item.paramValue)
                            $scope.openSyncFlag = paramValue.openSyncFlag
                            $scope.historyOpen = paramValue.historyOpen
                            $scope.historyStart = paramValue.historyStart

                            if(paramValue.invoiceType && paramValue.invoiceType.length>0){
                                $scope.syncInvoiceType.forEach(i => {
                                    var selected = false
                                    paramValue.invoiceType.forEach(p => {
                                        if(i.enumCode === p){
                                            selected = true
                                        }
                                    });
                                    i.selected = selected
                                })
                            }
                            if(paramValue.syncFileType && paramValue.syncFileType.length>0){
                                $scope.syncFileType.forEach(i => {
                                    var selected = false
                                    paramValue.syncFileType.forEach(p => {
                                        if(i.enumCode === p){
                                            selected = true
                                        }
                                    });
                                    i.selected =selected
                                })
                            }else{
                                paramValue.syncFileType =[]
                            }
                            if(paramValue.syncSelectedDateScope){
                                $scope.selectedDateScope = paramValue.syncSelectedDateScope
                            }
                        }
                        $('#history-start').val($scope.historyStart)
                        setTimeout(function() {
                            $('#history-start').datetimepicker({
                                autoclose: true,
                                minView: 'month', // 选择日期后，不会再跳转去选择时分秒
                                language: 'zh-CN',
                                format: 'yyyy-mm-dd',
                                forceParse: 0,
                                bootcssVer: 3,
                                pickTime: false,
                                pickerPosition: 'top-right',
                            }).on('changeDate', (e) => {
                                $scope.historyStart = e.target.value
                            });
                        }, 100);


                        $scope.changeSyncFlag = function changeSyncFlag(val){
                            if(val===1){
                                $scope.openSyncFlag = 1
                            }else{
                                $scope.openSyncFlag = 0
                            }
                        }
                        $scope.changeHistorySyncFlag = function changeHistorySyncFlag(val){
                            if(val===1){
                                $scope.historyOpen = 1
                            }else{
                                $scope.historyOpen = 0
                            }
                        }
                        $scope.changeSyncDateScope = function changeSyncDateScope(val){
                            $scope.selectedDateScope = val
                        }
                        $scope.ok = function ok() {
                            var paramValue = {}
                            paramValue.openSyncFlag = $scope.openSyncFlag
                            var fileTypes = []
                            $scope.syncFileType.forEach(i => {
                                if(i.selected){
                                    fileTypes.push(i.enumCode)
                                }
                            })

                            paramValue.syncFileType = fileTypes

                            var invoiceTypes = []
                            $scope.syncInvoiceType.forEach(i => {
                                if(i.selected){
                                    invoiceTypes.push(i.enumCode)
                                }
                            })

                            paramValue.invoiceType = invoiceTypes

                            paramValue.syncSelectedDateScope = $scope.selectedDateScope
                            paramValue.historyOpen = $scope.historyOpen
                            paramValue.historyStart = $scope.historyStart
                            paramValue.historyOver = false
                            obj.item.paramValue = JSON.stringify(paramValue)
                            console.log(obj.item)
                            updateHandle(obj.item)
                            $uibModalInstance.close()
                        }
                        $scope.cancel = function cancel() {
                            $uibModalInstance.close()
                        }
                    }],
                    resolve: {
                        obj() {
                            return {
                                item
                            }
                        },
                    },
                })
            } else if (item.paramCode === "ovat_invoice_pool_collect_conf") {
                $uibModal.open({
                    templateUrl: 'contrastRules.html',
                    openedClass: 'mod-modal mod-modal-hg',
                    animation: true,
                    controller: ['$scope', '$uibModalInstance', 'logger', 'sweetalert', 'obj', function ($scope, $uibModalInstance, logger, sweetalert, obj) {
                        $scope.paramCode = 'ovat_invoice_pool_collect_conf'
                        $scope.title = '销项发票同步/下载参数设置'
                        $scope.openSyncFlag = 0
                        $scope.syncInvoiceType = [
                            {enumCode: '62', enumName: '电子发票（增值税专用发票）', selected: true},
                            {enumCode: '61', enumName: '电子发票（普通发票）', selected: true},
                            {enumCode: '0', enumName: '增值税专用发票', selected: true},
                            {enumCode: '2', enumName: '增值税普通发票', selected: true},
                            {enumCode: '51', enumName: '增值税电子普通发票', selected: true},
                            //{enumCode: '63', enumName: '电子发票（铁路电子客票）', selected: false},
                            //{enumCode: '64', enumName: '电子发票（航空运输客票电子行程单)', selected: false},
                            {enumCode: '66', enumName: '纸质发票（增值税专用发票）', selected: false},
                            {enumCode: '67', enumName: '纸质发票（普通发票）', selected: false},
                            {enumCode: '08', enumName: '增值税电子专用发票', selected: true},
                            //{enumCode: '14', enumName: '通行费发票', selected: false},
                            //{enumCode: '12', enumName: '机动车销售统一发票', selected: false},
                            //{enumCode: '69', enumName: '机动车销售电子统一发票', selected: false},
                            //{enumCode: '65', enumName: '二手车销售电子统一发票', selected: false},
                            //{enumCode: '70', enumName: '纸质发票（机动车销售统一发票）', selected: false},
                            //{enumCode: '68', enumName: '纸质发票（二手车销售统一发票）', selected: false},
                            //{enumCode: '15', enumName: '二手车销售统一发票', selected: false}
                        ]
                        $scope.syncFileType = [{enumCode: 'XML', enumName: 'XML', selected: true},{enumCode: 'PDF', enumName: 'PDF', selected: true},{enumCode: 'OFD', enumName: 'OFD', selected: true}]
                        $scope.syncInvoiceDateScope = [{enumCode: '1', enumName: '前一天'},{enumCode: '3', enumName: '近3天(含当天)'},{enumCode: '7', enumName: '近7天(含当天)'}]
                        $scope.selectedDateScope = '7'
                        $scope.historyOpen = 0
                        $scope.historyStart = ''
                        if(obj.item && obj.item.paramValue){
                            // 保存过配置，根据配置调整初始化值
                            var paramValue = JSON.parse(obj.item.paramValue)
                            $scope.openSyncFlag = paramValue.openSyncFlag
                            $scope.historyOpen = paramValue.historyOpen
                            $scope.historyStart = paramValue.historyStart
                            if(paramValue.invoiceType  && paramValue.invoiceType.length>0){
                                $scope.syncInvoiceType.forEach(i => {
                                    var selected = false
                                    paramValue.invoiceType.forEach(p => {
                                        if(i.enumCode === p){
                                            selected = true
                                        }
                                    });
                                    i.selected = selected
                                })
                            }
                            if(paramValue.syncFileType && paramValue.syncFileType.length>0){
                                $scope.syncFileType.forEach(i => {
                                    var selected = false
                                    paramValue.syncFileType.forEach(p => {
                                        if(i.enumCode === p){
                                            selected = true
                                        }
                                    });
                                    i.selected =selected
                                })
                            }
                            if(paramValue.syncSelectedDateScope){
                                $scope.selectedDateScope = paramValue.syncSelectedDateScope
                            }
                        }

                        $('#ovat-history-start').val($scope.historyStart)
                        setTimeout(function() {
                            $('#ovat-history-start').datetimepicker({
                                autoclose: true,
                                minView: 'month', // 选择日期后，不会再跳转去选择时分秒
                                language: 'zh-CN',
                                format: 'yyyy-mm-dd',
                                forceParse: 0,
                                bootcssVer: 3,
                                pickTime: false,
                                pickerPosition: 'top-right',
                            }).on('changeDate', (e) => {
                                $scope.historyStart = e.target.value
                            });
                        }, 100);

                        $scope.changeSyncFlag = function changeSyncFlag(val){
                            if(val===1){
                                $scope.openSyncFlag = 1
                            }else{
                                $scope.openSyncFlag = 0
                            }
                        }
                        $scope.changeHistorySyncFlag = function changeHistorySyncFlag(val){
                            if(val===1){
                                $scope.historyOpen = 1
                            }else{
                                $scope.historyOpen = 0
                            }
                        }
                        $scope.changeSyncDateScope = function changeSyncDateScope(val){
                            $scope.selectedDateScope = val
                        }
                        $scope.ok = function ok() {
                            var paramValue = {}
                            paramValue.openSyncFlag = $scope.openSyncFlag
                            var fileTypes = []
                            $scope.syncFileType.forEach(i => {
                                if(i.selected){
                                    fileTypes.push(i.enumCode)
                                }
                            })
                            if(fileTypes.length>0){
                                paramValue.syncFileType = fileTypes
                            }
                            var invoiceTypes = []
                            $scope.syncInvoiceType.forEach(i => {
                                if(i.selected){
                                    invoiceTypes.push(i.enumCode)
                                }
                            })
                            if(invoiceTypes.length>0){
                                paramValue.invoiceType = invoiceTypes
                            }
                            paramValue.syncSelectedDateScope = $scope.selectedDateScope
                            paramValue.historyOpen = $scope.historyOpen
                            paramValue.historyStart = $scope.historyStart
                            paramValue.historyOver = false
                            obj.item.paramValue = JSON.stringify(paramValue)
                            console.log(obj.item)
                            updateHandle(obj.item)
                            $uibModalInstance.close()
                        }
                        $scope.cancel = function cancel() {
                            $uibModalInstance.close()
                        }
                    }],
                    resolve: {
                        obj() {
                            return {
                                item
                            }
                        },
                    },
                })
            }
            else if (item.paramCode === 'register_email') {
                $uibModal
                    .open({
                        templateUrl: 'registerEmail.html',
                        openedClass: 'mod-modal mod-modal-md',
                        animation: true,
                        controller: [
                            '$scope',
                            '$uibModalInstance',
                            'obj',
                            function ($scope, $uibModalInstance, obj) {
                                $scope.selectVal = JSON.parse(obj.item.paramValue)
                                $scope.cancel = function cancel() {
                                    $uibModalInstance.close()
                                }
                                $scope.ok = function ok() {
                                    obj.item.paramValue = JSON.stringify($scope.selectVal)
                                    updateHandle(obj.item)
                                    $uibModalInstance.close()
                                }
                            },
                        ],
                        resolve: {
                            obj() {
                                return {
                                    item,
                                }
                            },
                        },
                    })
                    .result.then(() => { })
            }
            else {
                $uibModal.open({
                    templateUrl: 'contrastRules.html',
                    openedClass: 'mod-modal mod-modal-lg',
                    animation: true,
                    controller: ['$scope', '$uibModalInstance', 'obj', function ($scope, $uibModalInstance, obj) {
                        $scope.enterList = []
                        let selectVal = []
                        let word = ''
                        switch (obj.item.paramCode) {
                            case 'ivat_invoice_verify_conf':
                                $scope.title = '查验设置'
                                $scope.paramCode = 'ivat_invoice_verify_conf'
                                word = 'item'
                                break;
                            case 'ovat_pdf_file_name_rule':
                                $scope.title = '文件名设置'
                                $scope.tips = '请选择哪些字段作为发票文件名'
                                $scope.msg = '可选字段：'
                                word = 'item'
                                break;
                            case 'sys_goods_mapping_switch':
                                $scope.title = '对照规则'
                                $scope.tips = '请选择哪些入口进入的数据需要启用商品对照表功能'
                                $scope.msg = '生效数据入口：'
                                word = 'list'
                                break;
                            case 'ovat_send_file_type':
                                $scope.title = '全电发票交付文件类型设置'
                                $scope.paramCode = 'ovat_send_file_type'
                                word = 'item'
                                break;
                            default:
                                break;
                        }
                        try {
                            $scope.enterList = JSON.parse(obj[word].paramSelection).operations || []
                            selectVal = obj[word].paramValue.split(',')
                        } catch (err) {
                            console.log('参数错误')
                        }
                        selectVal.forEach(item => {
                            for (var i = 0, len = $scope.enterList.length; i < len; i++) {
                                if (item == $scope.enterList[i].enumCode) {
                                    $scope.enterList[i].selected = true
                                    $scope.param = {
                                        paramValue: $scope.enterList[i].enumCode
                                    }
                                    break
                                }
                            }
                        })
                        if ($scope.paramCode == 'ivat_invoice_verify_conf') {
                            $scope.enterList.forEach(i => {
                                i.list = i.enumName.split('|')
                            })
                        }
                        $scope.cancel = function cancel() {
                            $uibModalInstance.close()
                        }

                        $scope.ok = function ok() {
                            let paramValue = []
                            if ($scope.paramCode == 'ivat_invoice_verify_conf') {
                                paramValue.push($scope.param.paramValue)
                            } else {
                                $scope.enterList.forEach(item => {
                                    if (item.selected) paramValue.push(item.enumCode)
                                })
                            }
                            obj[word].paramValue = paramValue.join(',')
                            if (obj[word].paramCode == 'ovat_send_file_type' && !obj[word].paramValue) {
                                logger.logTips('请至少选择一种交付的文件类型', 'warn')
                                return false
                            }
                            updateHandle(obj[word])
                            $uibModalInstance.close()
                        }
                    }],
                    resolve: {
                        obj() {
                            return {
                                list: $scope.param.ovatConf[0],
                                item
                            }
                        },
                    },
                }).result.then(() => {

                })
            }
        }
        $scope.syncParamRules = (item) => {
            if (item.paramCode === "ivat_invoice_pool_collect_conf" || item.paramCode === "ovat_invoice_pool_collect_conf") {
                if(!item.paramValue){
                    if(item.paramCode === "ivat_invoice_pool_collect_conf"){
                        logger.logTips('请提前设置进项发票同步规则！', 'warn')
                    }else {
                        logger.logTips('请提前设置销项发票同步规则！', 'warn')
                    }
                    return false
                }
                if(!localStorage.user_info){
                    logger.logTips('未获取到您的组织权限信息！', 'warn')
                    return false
                }
                const _userInfo = JSON.parse(localStorage.user_info)
                if(!_userInfo.orgList || _userInfo.orgList.length<1){
                    logger.logTips('未获取到您的组织权限信息！', 'warn')
                    return false
                }
                $uibModal.open({
                    templateUrl: 'paramSyncToOtherOrgs.html',
                    penedClass: 'mod-modal mod-modal-md',
                    animation: true,
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'httpRequest',
                        ($scope, $uibModalInstance, httpRequest) => {
                            $scope.checkedAllFlag = false
                            var orgSetting = {
                                check: {
                                    //如果没有设置配置项，取默认配置
                                    enable: true, //显示不显示复选框
                                    chkboxType: {
                                        Y: 's',
                                        N: 'ps',
                                    },
                                },
                                data: {
                                    simpleData: {
                                        enable: true, //true / false 分别表示 使用 / 不使用 简单数据模式
                                        idKey: 'orgId', //节点数据中保存唯一标识的属性名称 默认值id
                                        pIdKey: 'parentId', //节点数据中保存其父节点唯一标识的属性名称 默认值："pId"
                                        rootPId: null, // 用于修正根节点父节点数据，即 pIdKey 指定的属性值 默认值：null
                                    },
                                    key: {
                                        name: 'orgName',
                                    },
                                },
                                view: {
                                    showIcon: false, //是否显示节点的图标
                                    showLine: false, //是否显示节点之间的连线
                                },
                                callback: {
                                    onCheck: function (event, treeId, treeNode) {
                                        var userOrgTreeObj = $.fn.zTree.getZTreeObj('userOrgTree')
                                        $scope.userOrgCheckedList = userOrgTreeObj.getNodes()
                                    },
                                },
                            }

                            async function init() {
                                // 获取当前用户拥有的机构信息
                                const _userInfo = JSON.parse(localStorage.user_info)
                                if(!_userInfo.orgList || _userInfo.orgList.length<1){
                                    logger.logTips('未获取到您的组织权限信息！', 'warn')
                                    return false
                                }
                                $.fn.zTree.init($('#userOrgTree'), orgSetting, _userInfo.orgList)
                                fuzzySearch('userOrgTree', '#search_userOrgTree')
                                setChangeCheck()
                                $('#py_change').bind('change', setChangeCheck)
                                $('#sy_change').bind('change', setChangeCheck)
                                $('#pn_change').bind('change', setChangeCheck)
                                $('#sn_change').bind('change', setChangeCheck)
                            }
                            setTimeout(() => {
                                init()
                            }, 500)

                            function setChangeCheck() {
                                let zTree = $.fn.zTree.getZTreeObj('userOrgTree'),
                                    py = $('#py_change').attr('checked') ? 'p' : '',
                                    sy = $('#sy_change').attr('checked') ? 's' : '',
                                    pn = $('#pn_change').attr('checked') ? 'p' : '',
                                    sn = $('#sn_change').attr('checked') ? 's' : '',
                                    type = { Y: py + sy, N: pn + sn }
                                zTree.setting.check.chkboxType = type
                            }
                            $scope.userOrgCheckAll = function (type) {
                                let treeObj = $.fn.zTree.getZTreeObj('userOrgTree')
                                treeObj.checkAllNodes(type)
                                $scope.userOrgCheckedList = treeObj.getNodes()
                            }
                            /*$scope.checkAll = function (){
                                if($scope.checkedAllFlag){
                                    $scope.checkedAllFlag = false
                                }else {
                                    $scope.checkedAllFlag = true
                                }
                                $scope.userOrgCheckAll($scope.checkedAllFlag)
                            }*/

                            $scope.ok = function ok() {
                                if (!$scope.userOrgCheckedList) {
                                    return logger.logError('请选择需要同步的组织机构！')
                                }
                                // 遍历取得需要同步的组织
                                var selectedOrgId = []
                                $scope.userOrgCheckedList.forEach( item => {
                                    if(item.checked){
                                        selectedOrgId.push(item.orgId)
                                    }
                                })
                                const data = {
                                    "paramCode": item.paramCode,
                                    "orgIds": selectedOrgId,
                                }
                                utils.loading('请求发送中...')
                                httpRequest.post_syncSysParam(data).then((res) => {
                                    logger.logSuccess('同步成功')
                                    $uibModalInstance.close()
                                    setTimeout(() => {
                                        queryList()
                                    }, 1000)
                                }).finally(() => {
                                    utils.loaded()
                                })
                            }
                            $scope.cancel = function cancel() {
                                $uibModalInstance.dismiss()
                            }
                        },
                    ],
                    resolve: {
                        obj() {
                            return {
                                item
                            }
                        },
                    },
                })
            }
        }
        queryInfo()
    }
}

systemParamsListCtrl.$inject = ['$rootScope', '$scope', '$uibModal', 'logger', 'httpRequest']
export default systemParamsListCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/systemParams/systemParamsListCtrl.js